// import * as React from "react";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
// import Checkbox from "@mui/material/Checkbox";
// import { useEffect } from "react";
// import { useState } from "react";

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// const names = [
//   "Oliver Hansen",
//   "Van Henry",
//   "April Tucker",
//   "Ralph Hubbard",
//   "Omar Alexander",
//   "Carlos Abbott",
//   "Miriam Wagner",
//   "Bradley Wilkerson",
//   "Virginia Andrews",
//   "Kelly Snyder",
// ];

// export default function ExportContactMultiSelect({ data, parentCallback,MenuItemPhoneBook }) {
//   const [personName, setPersonName] = React.useState([]);
//   const [multiList, setMultiList] = useState([]);
//   console.log("multi list--", multiList);
//   console.log("variant name--", personName);
//   const handleChange = (event) => {

//     const {
//       target: { value },
//     } = event;
//     setPersonName(
//       // On autofill we get a stringified value.
//       typeof value === "string" ? value.split(",") : value
//     );
//   };

//   useEffect(() => {
//     let temp_arr = [];
//     for (let i = 0; i < personName.length; i++) {
//       temp_arr.push(personName[i]?.id);
//     }
//     setMultiList(temp_arr);
//   }, [personName]);

//   const sendData = () => {
//     parentCallback(multiList);
//   };

//   useEffect(() => {
//     sendData();
//   }, [multiList]);
//   return (
//     <div>
//       <FormControl sx={{ m: 1, width: 300 }}>
//         <InputLabel id="demo-multiple-checkbox-label">Group List</InputLabel>
//         <Select
//           disabled={MenuItemPhoneBook==undefined}
//           // disabled={true}
//           labelId="demo-multiple-checkbox-label"
//           id="demo-multiple-checkbox"
//           multiple
//           value={personName}
//           onChange={handleChange}
//           input={<OutlinedInput label="Group List" />}
//           //   renderValue={(selected) => selected.name.join(", ")}
//           renderValue={(selected) => selected.map((x) => x.phonebookName).join(", ")}
//           MenuProps={MenuProps}
//         >
//           {data.map((arg) => (
//             <MenuItem key={arg.id} value={arg}>
//               <Checkbox checked={personName.indexOf(arg) > -1} />
//               {/* <Checkbox
//                 checked={
//                     personName.findIndex(
//                     (item) => item.accountId === variant.accountId
//                   ) >= 0
//                 }
//               /> */}
//               <ListItemText primary={arg.phonebookName} />
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//     </div>
//   );
// }














import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import { useState } from "react";
import { Chip } from "@mui/material";

const ExportContactMultiSelect = ({
  disabledval,
  parentCallback,
  ContactArray,
  data,MenuItemPhoneBook
}) => {

  const [personName, setPersonName] = React.useState([]);
  const [multiList, setMultiList] = useState([]);
  const [variants, setVariants] = React.useState([]);
  const [state,  setState] = React.useState("");
  const [targetid, setTargetId] = React.useState([]);
// const sendData = () => {
//     // parentCallback(variantName);
//     parentCallback(targetid);
//   };
//   React.useEffect(async () => {
//     sendData();
//   }, [sendData]);
useEffect(()=>{
  setVariants(data)
},[data])
// useEffect(()=>{
//   let temp_arr=[]
//   for (let i = 0; i < state.length; i++){
//     temp_arr.push(state[i].id)
//   }
//   setTargetId(temp_arr)
// },[state])

useEffect(()=>{
  parentCallback(state)
},[state])

  return (
    <div className="w-100">
      {/* <Autocomplete
          disabled={MenuItemPhoneBook==undefined}
size="small"
style={{
      paddingRight: "0rem !important",
          }}
        fullWidth
        value={state}
        onChange={(e, val) => {
          setState(val);
        }}
        multiple
        limitTags={2}
        id="multiple-limit-tags"
        options={variants}
        getOptionLabel={(option) => option.phonebookName}
        // defaultValue={mappingArray}
        renderInput={(params) => (
          <TextField
            required
            // disabled={mappingDisable}
            size="small"
            fullWidth
            {...params}
            label="PhoneBook List"
            placeholder="PhoneBook List"
          />
        )}

      /> */}


      
<Autocomplete
    disabled={MenuItemPhoneBook==undefined}
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
        //                                 options={variants}
        // getOptionLabel={(option) => option?.bulkGroupName}
                                        options={variants}
                                        getOptionLabel={(option) =>
                                          option?.phonebookName || ""
                                        }
                                        // value={accountidvalue}
                                        // onChange={handleChange12}
                                        // onChange={(e, value) => {
                                        //   console.log("value--", value);
                                        //   setAccountIdValue(value);
                                        //   // setAccountCountryId(value);
                                        // }}
                                        onChange={(e, val) => {
           setState(val);
          console.log("kj",val)
        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="PhoneBook List"
                                          />
                                        )}
                                      />
    </div>
  );
};

export default ExportContactMultiSelect;
